import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.57 7.36C2.79 5.73.773 4.018.773 4.018-.197 3.18-.265 1.753.633.82l.16-.166c.893-.928 2.27-.86 3.076.146 0 0 3.22 4.091 4.947 5.885q.317.329.682.675zM.363 13.383C.163 11.984 0 9.705 0 8.799h23.53c0 1.133-.164 3.194-.363 4.583l-.09.62c-.4 2.796-2.832 5.061-5.424 5.061H5.876c-2.595 0-5.024-2.265-5.425-5.06zm4.343 7.148h14.117v2.444H4.706z"
    }, null, -1)
  ]))]))
}
export default { render: render }